import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Inicio', path: '/' },
    { name: 'Nuestra Historia', path: '/historia' },
    { name: 'Carta', path: '/menu' },
    { name: 'Catering', path: '/catering' },
    { name: 'Contacto', path: '/contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/10 backdrop-blur-md'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/c2de9fc4-8c8a-413f-a0d6-2aaa28cbaee1.png"
              alt="El Bocado"
              className="h-14 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors duration-300 hover:text-[#8B5A3C] cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#8B5A3C]'
                    : isScrolled
                    ? 'text-[#3E2723]'
                    : 'text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <Link
            to="/contact"
            className={`hidden md:inline-flex items-center gap-2 px-6 py-3 font-semibold rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'bg-[#FFF8E7] text-[#3E2723] hover:bg-[#EDE0C4]'
                : 'bg-white text-[#3E2723] hover:bg-white/90'
            }`}
          >
            Hacer Pedido
            <i className="ri-phone-line"></i>
          </Link>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-[#3E2723]' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 font-medium transition-colors duration-300 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-[#8B5A3C]'
                    : 'text-[#3E2723] hover:text-[#8B5A3C]'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block w-full text-center px-6 py-3 bg-[#FFF8E7] text-[#3E2723] font-semibold rounded-full hover:bg-[#EDE0C4] transition-all duration-300 cursor-pointer"
            >
              Hacer Pedido
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}